import { addToastNotification, updateStatus } from 'redux/actions';
import {
  getAlerts,
  createAlert,
  updateAlert,
  deleteAlert,
  activateAlert,
  alertExport,
  importAlert,
  duplicateAlert,
  getAlertRules,
  getAlertRulesMetrics,
  getListAlertEvents,
  createRule,
  alertRulesGetConnectionInfo,
  deleteAlertRules,
  getAlertRulesShortInfo,
  duplicateRule,
  updateRule,
  setCountOfViewedEvents
} from 'apis/AlertsManagement';
import { Status } from 'apis/Status';
import ActionTypes from './ActionTypes';

function setAlertList(alerts) {
  return {
    type: ActionTypes.SET_ALERT_LIST,
    alerts
  };
}

function deleteAlertStorage(id) {
  return {
    type: ActionTypes.DELETE_ALERT,
    id
  };
}

export function doAlertGetList(cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const getAlertsStatus = 'GET-Alerts';

    dispatch(updateStatus(getAlertsStatus, Status.PENDING));
    getAlerts()
      .then((result) => {
        dispatch(setAlertList(result.syntheticAlerts));
        dispatch(updateStatus(getAlertsStatus, Status.SUCCESS));

        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(getAlertsStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: 'get-alert-list',
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}

export function doAlertCreate(data, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const createAlertStatus = 'POST-Alert';

    dispatch(updateStatus(createAlertStatus, Status.PENDING));
    createAlert(data)
      .then((result) => {
        dispatch(doAlertGetList());
        dispatch(updateStatus(createAlertStatus, Status.SUCCESS));

        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(createAlertStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: data.name,
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}

export function doAlertExport(data, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const getStatus = 'POST-AlertExport';

    dispatch(updateStatus(getStatus, Status.PENDING));
    alertExport(data)
      .then((result) => {
        dispatch(updateStatus(getStatus, Status.SUCCESS));

        if (cb_success) cb_success(result.syntheticAlert);
      })
      .catch((error) => {
        dispatch(updateStatus(getStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: data.id,
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}

export function doAlertImport(data, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const getStatus = 'Import-Alert';

    dispatch(updateStatus(getStatus, Status.PENDING));
    importAlert(data)
      .then((result) => {
        dispatch(updateStatus(getStatus, Status.SUCCESS));

        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(getStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: 1,
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}

export function doAlertDuplicate(data, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const duplicateAlertStatus = 'POST-Alert';

    dispatch(updateStatus(duplicateAlertStatus, Status.PENDING));
    duplicateAlert(data)
      .then((result) => {
        const alert = result.syntheticAlert;
        dispatch(doAlertGetList());
        dispatch(updateStatus(duplicateAlertStatus, Status.SUCCESS));
        dispatch(
          addToastNotification({
            id: alert.name,
            title: '',
            description: `Copy of alert '${alert.name}' created successfully`
          })
        );

        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(duplicateAlertStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: data.name,
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}

export function doAlertUpdate(alertId, data, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const updateAlertStatus = 'PUT-Alert';

    dispatch(updateStatus(updateAlertStatus, Status.PENDING));
    updateAlert(alertId, data)
      .then((result) => {
        dispatch(doAlertGetList());
        dispatch(updateStatus(updateAlertStatus, Status.SUCCESS));

        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(updateAlertStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: data.name,
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}

export function doAlertDelete(alertId, cb_success = null, cb_fail = null) {
  const deleteAlertsStatus = 'DELETE-Alerts';

  return (dispatch) => {
    deleteAlert(alertId)
      .then((result) => {
        dispatch(deleteAlertStorage(alertId));
        dispatch(updateStatus(deleteAlertsStatus, Status.SUCCESS));

        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(deleteAlertsStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: 'delete-alert',
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}

export function doAlertActive(data, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const activateAlertsStatus = 'Activate-Alerts';

    dispatch(updateStatus(activateAlertsStatus, Status.PENDING));
    activateAlert(data)
      .then((result) => {
        dispatch(doAlertGetList());
        dispatch(updateStatus(activateAlertsStatus, Status.SUCCESS));

        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(activateAlertsStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: 'activate-alert',
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}

export function doAlertGetListAlertEvents(request, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const getAlertsStatus = 'GET-List-Alert-Events';

    dispatch(updateStatus(getAlertsStatus, Status.PENDING));
    getListAlertEvents(request)
      .then((result) => {
        dispatch(updateStatus(getAlertsStatus, Status.SUCCESS));

        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(getAlertsStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: 'get-list-alert-events',
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}

// Alert rules action creators

function setAlertRulestList(alertRules) {
  return {
    type: ActionTypes.SET_ALERT_RULES_LIST,
    alertRules
  };
}

function setRulesMetrics(rulesMetrics) {
  return {
    type: ActionTypes.SET_RULES_METRICS_LIST,
    metrics: rulesMetrics
  };
}

function addRule(rule) {
  return {
    type: ActionTypes.ADD_RULE,
    rule
  };
}

function duplicateAlertRule(rule) {
  return {
    type: ActionTypes.DUPLICATE_RULE,
    rule
  };
}

function editAlertRule(rule) {
  return {
    type: ActionTypes.EDIT_RULE,
    rule
  };
}

export function doAlertRulesGetList(cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const getStatus = 'GET-AlertRules';

    dispatch(updateStatus(getStatus, Status.PENDING));
    getAlertRules()
      .then((result) => {
        dispatch(setAlertRulestList(result.rules));
        dispatch(updateStatus(getStatus, Status.SUCCESS));

        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(getStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: 'get-alert-rules-list',
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}

export function doAlertRulesGetConnectionInfo(alertRulesId, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const getStatus = 'GET-AlertRulesConnectionInfo';

    dispatch(updateStatus(getStatus, Status.PENDING));
    alertRulesGetConnectionInfo(alertRulesId)
      .then((result) => {
        dispatch(updateStatus(getStatus, Status.SUCCESS));

        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(getStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: 'get-alert-rules-metrics-list',
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}

export function doAlertRulesDelete(alertRulesId, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const deleteStatus = 'DELETE-AlertRules';

    dispatch(updateStatus(deleteStatus, Status.PENDING));
    deleteAlertRules(alertRulesId)
      .then((result) => {
        dispatch(updateStatus(deleteStatus, Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(deleteStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: 'delete-alert-rules',
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}

export function doGetRuleMetricsList(cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const getStatus = 'GET-RuleMetrics';

    dispatch(updateStatus(getStatus, Status.PENDING));
    getAlertRulesMetrics()
      .then((result) => {
        dispatch(setRulesMetrics(result.metrics));
        dispatch(updateStatus(getStatus, Status.SUCCESS));

        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(getStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: 'get-metrics-list',
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}

export function doRuleCreate(data, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const ruleCreationStatus = 'POST-Rule';

    dispatch(updateStatus(ruleCreationStatus, Status.PENDING));
    createRule(data)
      .then((result) => {
        dispatch(addRule(result.rule));
        dispatch(updateStatus(ruleCreationStatus, Status.SUCCESS));

        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(ruleCreationStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: 'create-alert-rule',
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}

export function doRuleDuplicate(data, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const duplicateRuleStatus = 'POST-Rule';

    dispatch(updateStatus(duplicateRuleStatus, Status.PENDING));
    duplicateRule(data)
      .then((result) => {
        const rule = result.duplicatedRule;

        dispatch(duplicateAlertRule(rule));
        dispatch(updateStatus(duplicateRuleStatus, Status.SUCCESS));
        dispatch(
          addToastNotification({
            id: rule.name,
            title: 'Success',
            description: `${rule.name} created`
          })
        );

        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(duplicateRuleStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: data.name,
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}

export function doRuleUpdate(ruleId, data, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const updateRuleStatus = 'PUT-Rule';

    dispatch(updateStatus(updateRuleStatus, Status.PENDING));
    updateRule(ruleId, data)
      .then((result) => {
        const rule = result.rule;

        dispatch(editAlertRule(rule));
        dispatch(updateStatus(updateRuleStatus, Status.SUCCESS));

        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(updateRuleStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: data.name,
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}

export function doAlertRulesGetShortInfo(deviceGroupId, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const getStatus = 'GET-AlertRulesShortInfo';
    dispatch(updateStatus(getStatus, Status.PENDING));

    getAlertRulesShortInfo(deviceGroupId)
      .then((result) => {
        dispatch(updateStatus(getStatus, Status.SUCCESS));
        if (cb_success) cb_success(result.rulesIdsList);
      })
      .catch((error) => {
        dispatch(updateStatus(getStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: 'get-alert-rules-short-info',
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}

export function doAlertsSetCountOfViewedEvents(data, cb_success = null, cb_fail = null) {
  return (dispatch) => {
    const getStatus = 'POST-AlertsSetCountOfViewedEvents';
    dispatch(updateStatus(getStatus, Status.PENDING));

    setCountOfViewedEvents(data)
      .then((result) => {
        dispatch(updateStatus(getStatus, Status.SUCCESS));
        if (cb_success) cb_success(result);
      })
      .catch((error) => {
        dispatch(updateStatus(getStatus, Status.FAILURE));

        if (error.cause) {
          dispatch(
            addToastNotification({
              id: 'post-alerts-set-count-of-viewed-events',
              title: 'Error',
              description: error.message
            })
          );

          if (cb_fail) cb_fail(error.message);
        }
      });
  };
}
